require([ './js/main'], function(m){
    console.log("application was started")
});